import { KeyValue } from "@/main/models/common";

export enum ClaimFileCategoryTypes {
	GET_CLAIM_FILE_CATEGORY = "@claimFileCategory/GET_CLAIM_FILE_CATEGORY",
	SAVE_CLAIM_FILE_CATEGORY = "@claimFileCategory/SAVE_CLAIM_FILE_CATEGORY",
	RESET_REDUCER_CLAIM_FILE_CATEGORY = "@claimFileCategory/RESET_REDUCER_CLAIM_FILE_CATEGORY",
}

export interface ClaimFileCategoryState {
	readonly claimFileCategory: {
		data: KeyValue[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
}

export interface GetClaimFileCategory {
	type: typeof ClaimFileCategoryTypes.GET_CLAIM_FILE_CATEGORY;
}

export interface SaveClaimFileCategory {
	type: typeof ClaimFileCategoryTypes.SAVE_CLAIM_FILE_CATEGORY;
	payload: {
		data: KeyValue[] | null;
		isError: boolean;
		errorMessages: string[] | null;
	};
}

export interface ResetReducerClaimFileCategory {
	type: typeof ClaimFileCategoryTypes.RESET_REDUCER_CLAIM_FILE_CATEGORY;
}

export type ClaimFileCategoryActionTypes = GetClaimFileCategory | SaveClaimFileCategory | ResetReducerClaimFileCategory;
